// eslint-disable-next-line prefer-destructuring
const NODE_ENV = process.env.NODE_ENV;

export function isDev() {
  return NODE_ENV === 'staging';
}

/**
 * console.log only in development
 */
function logIfDev() {
  let log = function log() {};

  if (console && isDev()) {
    /* eslint-disable no-console */
    log = console.log.bind(console);
    /* eslint-enable no-console */
  }

  return log;
}

export const debug = logIfDev();
